/* SP-SDE draft All Products card reveal; native links and quick-add untouched. */
(() => {
  'use strict';
  if (window.__spzAllProductsOfferV1) return;
  window.__spzAllProductsOfferV1 = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-spz-collection-offer-trigger]');
    if (!button) return;
    const offer = button.closest('[data-spz-collection-offer]');
    const details = offer?.querySelector('[data-spz-collection-offer-details]');
    if (!details) return;
    event.preventDefault();
    event.stopPropagation();
    const open = button.getAttribute('aria-expanded') !== 'true';
    details.hidden = !open;
    button.setAttribute('aria-expanded', String(open));
    button.textContent = open ? 'Hide your direct-purchase offer' : 'Reveal your direct-purchase offer';
  });
})();
